import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { z } from "zod";

export const getAdvancedFlowCount = {
  input: z.object({ schema: z.nativeEnum(SchemaType) }),
  output: z.object({ count: z.number() }),
};
